module.exports = __webpack_public_path__ + "static/img/cbuenosaires.003204d3.svg";